import { useQueryClient } from '@tanstack/react-query'

import {
  RejectionReason,
  SubmitCheckFormValues,
  SubmitCheckOutcome
} from '../checksSummary/submitCheckModal/SubmitCheckModal.types'

import {
  MonetaryVerificationCheckStatus,
  MonetaryVerificationDetails
} from '@percent/admin-dashboard/api/actions/monetaryVerifications/monetaryVerifications.types'
import { SingleAdminValidationSubmission } from '@percent/domain/verifications'

export function useCreateSubmitCheckHelpers(
  monetaryVerification: MonetaryVerificationDetails,
  checkStatus?: MonetaryVerificationCheckStatus,
  validationSubmission?: SingleAdminValidationSubmission | null
) {
  const queryClient = useQueryClient()

  const createRequestPayload = (formData: SubmitCheckFormValues) => {
    const reason =
      formData.rejectionReason === RejectionReason.CUSTOM_REASON && formData.customRejectionReason
        ? formData.customRejectionReason
        : formData.rejectionReason

    return {
      verificationId: monetaryVerification.id,
      model: {
        configurationId: monetaryVerification.configurationId,
        resolution: formData.outcome,
        reason: formData.outcome === SubmitCheckOutcome.REJECT ? reason : undefined,
        isMistakeCorrection:
          checkStatus !== MonetaryVerificationCheckStatus.PENDING ? formData.isMistakeCorrection : undefined
      }
    }
  }

  const invalidateQueryKeys = (overrideQueryKeys?: string[]) => {
    const queryKeysToInvalidate = [
      ['v1/admin/monetary-donation-verifications', monetaryVerification?.id],
      ['v1/admin/organisation', monetaryVerification?.organisationId],
      ['v1/admin/validation-submission', validationSubmission?.id],
      ...(overrideQueryKeys || [])
    ]
    queryClient.invalidateQueries({
      predicate: ({ queryKey }) => {
        return queryKeysToInvalidate.some(
          keyToInvalidate => JSON.stringify(queryKey) === JSON.stringify(keyToInvalidate)
        )
      }
    })
  }

  return {
    createRequestPayload,
    invalidateQueryKeys
  }
}
